import { Header } from '@/components/Header.tsx'
import type { ReactNode } from 'react'

type Props = {
  children: ReactNode
}

export const ProjectLayout = ({ children }: Props) => {
  return (
    <div className="h-dvh flex flex-col w-screen bg-surface-background">
      <Header />
      <div className="flex-1 overflow-auto">{children}</div>
    </div>
  )
}
